import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";

export function ListingsToolbar() {
  const nav = useNavigate();
  const canCreate = useActionPermission(["listings:update"]);

  return (
    <div className="mb-2 flex flex-wrap items-center justify-between gap-4 space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">
          ການກວດກາ Marketplace
        </h2>
        <p className="text-muted-foreground text-sm">
          ດູລາຍການສິນຄ້າບນ marketplace ຕວດສອບເນື້ອຫາ ຮູບ ລາຄາ ແລະ ຂໍ້ມູນຮ້ານ.
        </p>
      </div>
      {canCreate ? (
        <Button
          onClick={() => nav({ to: "/app/moderation/listings/create" })}
        >
          ສ້າງ listing
        </Button>
      ) : null}
    </div>
  );
}
